import React from 'react';
import { useSelector } from 'react-redux';
import { HistoryWrapper, EmptyHistory, ReferStatusHistory } from './styles';
import { InstaremAvatar } from '@Components';
import { ReferHistoryProps, History } from '../interface';
import { REFERRAL_SMALL_ICON, ALERT_BELL_ICON } from '@Images';
import { selectUserStatusReducer } from '@Redux/selectors';
import { logEventV2 } from '@Utils/events/logUserEvents';
import {
  EVENT_ROUTE_KEYS,
  EventItemSection,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';

const ReferHistory: React.FC<ReferHistoryProps> = ({
  historyData,
  labels,
  url
}): React.ReactElement => {
  const isEmptyHistory = historyData?.length === 0;
  const referralActivity = labels?.referralActivitySection;
  const sendReminderActivity = referralActivity?.shareMessage;
  const sendReminderSubject = sendReminderActivity?.emailSubject;
  const sendReminderMessage = sendReminderActivity?.message;
  const userStatus = useSelector(selectUserStatusReducer);
  const fullName = userStatus?.remitter_individual_full_name;

  const logEvent = (historyItem: History, index: number) => {
    const eventProperty = {
      section: EventItemSection.TABS,
      item: historyItem?.status,
      position: index + 1,
      pageName: EVENT_ROUTE_KEYS.ReferralHistory,
      flowType: FLOW_TYPE.REFERRALS
    };
    logEventV2(EventNamesV2.ITEM_CLICKED, eventProperty);
  };

  const getDisplayName = (name?: string, email?: string) => {
    if (name) return name;
    if (!email) return '';

    return email.length > 15 ? `${email.slice(0, 15)}...` : email;
  };

  const renderHistoryItems = () => {
    return historyData.map((historyItem: History, index: number) => (
      <div className="index" key={index}>
        <div className="activityCard">
          <InstaremAvatar
            name={historyItem?.name || historyItem?.email}
            flagCode={historyItem?.referee_country_code}
          ></InstaremAvatar>
          <div className="statusContainer">
            <div className="referDetails">
              <span className="currenStatus">
                {getDisplayName(historyItem?.name, historyItem?.email)}
              </span>
              <div
                className={`statusBox ${historyItem?.status === 'Completed' ? 'completed' : ''}`}
              >
                {historyItem?.status}
              </div>
            </div>
            <span
              className={`status ${
                historyItem?.status === 'Completed' ? 'completedDescription' : ''
              }`}
            >
              {historyItem?.status_description}
            </span>
            {historyItem?.status !== 'Completed' && (
              <a
                href={`mailto:?subject=${sendReminderSubject}
                &body=${sendReminderMessage
                  .replace('{REFEREES_NAME}', historyItem?.name)
                  .replace('{REMITTER_NAME}', fullName)
                  .replace(/\n/g, '%0D%0A')}
                      `}
                id="email-link"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => logEvent(historyItem, index)}
                className="sendReminderContainer"
              >
                <img src={ALERT_BELL_ICON} alt="Alert Bell Icon" className="alertBellIcon" />
                <span className="sendReminderText">{referralActivity?.sendReminder}</span>
              </a>
            )}
          </div>
        </div>
        {index !== historyData.length - 1 && <div className="separationLine"></div>}
      </div>
    ));
  };

  return (
    <HistoryWrapper>
      {isEmptyHistory ? (
        <EmptyHistory>
          <div className="zeroReferBox">
            <div>
              <img alt="" src={REFERRAL_SMALL_ICON} />
            </div>
            <span className="emptyStaticText">{referralActivity?.noReferralFound}</span>
          </div>
        </EmptyHistory>
      ) : (
        <ReferStatusHistory>{renderHistoryItems()}</ReferStatusHistory>
      )}
    </HistoryWrapper>
  );
};

export default ReferHistory;
